import "./SearchResultStyles.scss";
import { IJSLComponent, IJSLVNode } from "jsl-render";
import { SearchResultDTO } from "../../../ajax/types/SearchResultDTO";

export class SearchResultComponent implements IJSLComponent {

    constructor(private data: SearchResultDTO) { }

    public render(): IJSLVNode {
        return <div class="col-lg-6 col-md-6">
            <a class="single-result m-1" href={"#tax/" + this.data.id}>
                {this.data.imageId ? <img src={"/Home/Thumbnail/" + this.data.imageId} class="tax-thumb" /> : null}
                <div class="fund-name"><div class="lat-name">{this.data.name}</div><div class="de-name">{this.data.deutscherName}</div></div>
                <div class="fund-count">{this.data.funde} Funde</div>
                {this.data.synName ?
                <div class="fund-syn">Synonyme: {this.data.synName.split("|").join(",")}</div> : null}
            </a>
        </div>;
    }

    public isEqual(node: IJSLComponent): boolean {
        return (this as any).__proto__ === (node as any).__proto__;
    }
}
